import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { SelectPicker } from "rsuite";

const sorting = (props: {
  orderBy: any;
  order: any;
  headCell: any;
  setOrderForSorting: any;
  rowSpan: any;
}) => {
  const { orderBy, order, headCell, setOrderForSorting, rowSpan } = props;
  const headerStyle = {
    backgroundColor: "black",
    color: "white",
    borderRight: "0.1px solid #333231",
    borderBottom: "0.2px solid #333231",
    height: "30px",
  };
  const fontStyle = {
    fontSize: "0.85vw",
    fontWeight: "normal",
    fontFamily:
      'BlinkMacSystemFont,-apple-system,"Segoe UI","Roboto","Oxygen","Ubuntu","Cantarell","Fira Sans","Droid Sans","Helvetica Neue","Helvetica","Arial",sans-serif;',
  };

  const handleRequestSort = (event: any, property: any) => {
    let newOrderBy = "";
    let newOrder = "";

    if (orderBy === property && order === "asc") {
      newOrder = "desc";
      newOrderBy = property;
    } else if (orderBy === property && order === "desc") {
      newOrder = "asc";
      newOrderBy = property;
    } else if (orderBy === "" && order === "") {
      newOrder = "asc";
      newOrderBy = property;
    }
    if (orderBy !== property) {
      newOrder = "asc";
      newOrderBy = property;
    }
    setOrderForSorting(newOrder, newOrderBy);
  };

  const createSortHandler = (property: any) => (event: any) => {
    handleRequestSort(event, property);
  };

  const getArrowDownward = (id: any) => <i className="fa">&#x2193;</i>;

  const getArrowUpward = (id: any) => <i className="fa">&#x2191;</i>;

  return (
    <Tooltip title={headCell.tooltip} arrow>
      <th
        className="stickyHeader alignCenter"
        style={headerStyle}
        onClick={createSortHandler(headCell.id)}
        rowSpan={rowSpan ? rowSpan : 1}
      >
        <Box display="flex" style={{ textAlign: "center", justifyContent:"center" }}>
          <Typography style={fontStyle}>{headCell.label}</Typography>
          
          {headCell.sortingRequired && headCell.id === orderBy ? (
            <Box style={{ fontSize: "0.7vw" }} marginLeft="2px">
              {order === "desc"
                ? getArrowDownward(headCell.id)
                : getArrowUpward(headCell.id)}
            </Box>
          ) : (
            ""
          )}
        </Box>
 
      </th>
    </Tooltip>
  );
};

export default sorting;
